// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FinStatisticV2_pageContainer__4sqsk {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 1rem;
  background: #f8f9fa;       /* фон внутри рамок */
  overflow-y: auto;          /* вертикальный скролл при переполнении */
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Manager/FinStatisticV2/FinStatisticV2.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,mBAAmB,QAAQ,qBAAqB;EAChD,gBAAgB,WAAW,yCAAyC;EACpE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX","sourcesContent":[".pageContainer {\r\n  height: 100%;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  padding: 1rem;\r\n  background: #f8f9fa;       /* фон внутри рамок */\r\n  overflow-y: auto;          /* вертикальный скролл при переполнении */\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `FinStatisticV2_pageContainer__4sqsk`
};
export default ___CSS_LOADER_EXPORT___;
